export default "__VITE_PUBLIC_ASSET__2a810c39__"